import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCalendarNavigation(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 33" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M10.333 6.833V4.167m11.334 2.666V4.167m-11.334 8h11.334M9 27.5h14a4 4 0 0 0 4-4V10.833a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4V23.5a4 4 0 0 0 4 4Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarNavigation);
export default ForwardRef;
